export const AddedToBasket = 'Varen er tilføjet til kurven';
export const ShopBasketUrl = '/shop/kurv';
